export default "__VITE_ASSET__4NwGCUYY__"